<template>
  <ul class="word__list">
    <li
      class="word__item m10 pnt"
      v-for="(item, index) in keywords"
      :key="index"
      @click="goPage(item.value)"
    >
      {{ item.label }}
    </li>
  </ul>
</template>
<script>
export default {
  name: 'component-reco-keywords',
  description: '검색 페이지 > 추천 검색어',
  data() {
    return {
      keywords: [
        { label: '인터넷 가입', value: 'INTERNET_APPLY' },
        { label: '휴대폰 견적', value: 'MOBILE_APPLY' },
        // { label: 'skylife', value: 'SKYLIFE' },
        { label: '우리동네 매장', value: 'STORE' },
        { label: '휴대폰', value: 'MOBILE' },
        { label: '인터넷', value: 'INTERNET' },
      ],
    };
  },
  methods: {
    goPage(type) {
      if (
        type === 'INTERNET_APPLY' ||
        type === 'SKYLIFE' ||
        type === 'MOBILE_APPLY'
      ) {
        // 견적 가능 여부 확인
        this.$emit('check-apply', type);
      } else if (type === 'STORE') {
        this.$router.push({ name: 'Shop.List' });
      } else if (type === 'MOBILE') {
        this.$emit('bind', '휴대폰');
      } else if (type === 'INTERNET') {
        this.$emit('bind', '인터넷');
      }
    },
  },
};
</script>
